<template>
  <div class="content-item" ref="cursorMain">
    <div class="cursor-select verticallyCenter" @click="openPositionSelects">
      <span :class="activeCursor.iconClass+' mr6 show-icon'"></span>
      <span class="flex1">{{ activeCursor.label }}</span>
      <span class="icon icon-portal-arrows-down text-right" :class="showPositionStyle ? 'rotate180' : ''"></span>
    </div>
    <div class="cursor-selects-wrap" v-show="showPositionStyle">
      <ul class="cursor-selects">
        <li
          v-for="(item, index) in cursorTypeList"
          :key="index"
          :class="[item.label === activeCursor.label ?'active':'','cursor-select-item verticallyCenter']"
          @click.stop="selectPositionStyle(item)"
        >
          <span :class="item.iconClass +' mr8 show-icon'"></span>
          <span>{{ item.label }}</span>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import "modules/common.css"

export default {
  name: "cx-cursor",
  props: {
    cursorType: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      showPositionStyle: false,
      cursorTypeList: [
        {
          label: "自动",
          value: "",
          iconClass: "icon-portal-default"
        }, {
          label: "默认",
          value: "default",
          iconClass: "icon-portal-default"
        }, {
          label: "手势",
          value: "pointer",
          iconClass: "icon-portal-pointer"
        }, {
          label: "禁用",
          value: "not-allowed",
          iconClass: "icon-portal-not-allowed"
        }, {
          label: "放大",
          value: "zoom-in",
          iconClass: "icon-portal-cursor-zoom-in"
        }, {
          label: "缩小",
          value: "zoom-out",
          iconClass: "icon-portal-cursor-zoom-out"
        }, {
          label: "文本",
          value: "text",
          iconClass: "icon-portal-cursor-text"
        }
      ]
    }
  },
  computed: {
    cursorTypeVal: {
      get() {
        return this.cursorType
      },
      set(val) {
        this.$emit("update:cursorType", val)
      }
    },
    activeCursor: {
      get() {
        let value = this.cursorTypeList.find(item => item.value === this.cursorTypeVal)
        return  value || this.cursorTypeList[0]
      },
      set(){

      }
    }
  },
  mounted() {
    document.addEventListener("click", this.bodyCloseMenus);
  },
  methods: {
    openPositionSelects() {
      this.showPositionStyle = true
    },
    selectPositionStyle(item) {
      this.cursorTypeVal = item.value
      this.activeCursor = item
      this.showPositionStyle = false
    },
    // 点击空白处关闭弹窗
    bodyCloseMenus(e) {
      let self = this;
      if (this.$refs.cursorMain && !this.$refs.cursorMain.contains(e.target)) {
        if (self.showPositionStyle == true){
          self.showPositionStyle = false;
        }
      }
    }
  },
  beforeDestroy() {
    document.removeEventListener("click", this.bodyCloseMenus);
  },
}
</script>

<style lang="scss" scoped>
span{
  font-size: 16px;
}
.cursor-select {
  background: var(--inputBg);
  border-radius: 4px;
  height: 32px;
  padding: 0 13px;
  box-sizing: border-box;
  cursor: pointer;
  .show-icon{
    color:var(--toolbarTipText)
  }
  .icon {
    //width: 20px;
    margin-right: 9px;
    pointer-events: none;
    transition: transform 0.3s;
    transform-origin: center center;
    &.rotate180 {
      transform: rotate(180deg);
    }

  }

  .text-right {
    font-size: 16px;
    width: 16px;
    text-align: right;

  }
}

.cursor-selects-wrap {
  position: absolute;
  width: 114px;
  box-shadow: 0 6px 16px -8px rgba(0, 0, 0, 0.08), 0px 8px 20px rgba(0, 0, 0, 0.12);
  border-radius: 4px;
  border: 1px solid var(--borderColorFour);
  padding: 4px 0;
  z-index: 9999;
  background-color: var(--elCollapseItemWrapBgColor);

  .cursor-select-item {
    padding: 0 12px;
    height: 38px;
    line-height: 38px;
    box-sizing: border-box;
    width: 100%;
    cursor: pointer;


    &:hover {
      background-color: var(--selectItemHoverBg);
    }
    &.active{
      color: var(--themeColor)
    }

  }
}
</style>
